export default __webpack_public_path__ + "static/media/empty_404.198272b8.svg";